/**
 * Topbar - port 1:1 z new-design/layout.jsx.
 *
 * Header z title + collapsed expand button + credit-pill.
 */
import { Icon } from "@/components/ui/Icon";
import { BrandMark } from "@/components/ui/BrandMark";
import { creditsTitle, formatCredits } from "@/lib/credits";

interface TopbarProps {
  title: string;
  titleDupe?: boolean;
  collapsed: boolean;
  onExpand: () => void;
  /** `null` = saldo jeszcze nie dojechało z API (patrz lib/credits). */
  credits: number | null;
  onBuy: () => void;
  /** Czy pokazać „+" prowadzące do doładowania (patrz useCreditPurchase). */
  canBuy?: boolean;
  onHelp?: () => void;
}

export function Topbar({ title, titleDupe, collapsed, onExpand, credits, onBuy, canBuy = true, onHelp }: TopbarProps) {
  return (
    <header className="topbar">
      <span className="topbar__logo">
        <span className="logo-mark"><BrandMark size={20} /></span>
      </span>
      {collapsed && (
        <button className="topbar__expand" onClick={onExpand} title="Rozwiń panel">
          <Icon name="menu" />
        </button>
      )}
      <div className={`topbar__title ${titleDupe ? "topbar__title--dupe" : ""}`}>{title}</div>
      <div className="topbar__spacer" />
      {onHelp && (
        <button className="topbar__help" onClick={onHelp} title="Pomoc">
          <Icon name="info" />
          <span>Pomoc</span>
        </button>
      )}
      {/* Bez doładowań pigułka jest tylko licznikiem — bez „+" i bez klikania,
          żeby nie prowadzić usera do zablokowanego cennika. */}
      {canBuy ? (
        <button className="credit-pill" onClick={onBuy} title={creditsTitle(credits, true)}>
          <span className="credit-pill__chip">
            <Icon name="coins" />
          </span>
          <span className="credit-pill__num">{formatCredits(credits)}</span>
          <span className="credit-pill__plus">
            <Icon name="plus" />
          </span>
        </button>
      ) : (
        <span className="credit-pill" title={creditsTitle(credits, false)}>
          <span className="credit-pill__chip">
            <Icon name="coins" />
          </span>
          <span className="credit-pill__num">{formatCredits(credits)}</span>
        </span>
      )}
    </header>
  );
}
